import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { I18nService } from '@recruitee/i18n';
import type { SelectOption } from '@recruitee/user-interface';
import { SelectComponent } from '@recruitee/user-interface';

import { Destroyable, takeUntilDestroyed } from '../../../common';
import type { DynamicRegionSelectInputConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';
import { DynamicFormLocationsService } from '../dynamic-form/dynamic-form-locations-service';

export class RegionSelectInput extends DynamicFormInput<DynamicRegionSelectInputConfig> {}

@Component({
  selector: 'rti-region-select-input',
  templateUrl: './region-select-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectComponent],
})
@Destroyable()
export class RegionSelectInputComponent {
  @Input() public input: RegionSelectInput;

  public loading: boolean = false;
  public regionOptions: Array<SelectOption<string>> = [];

  constructor(
    private cdRef: ChangeDetectorRef,
    private i18n: I18nService,
    private locationSvc: DynamicFormLocationsService,
  ) {}

  public ngOnInit(): void {
    this.locationSvc.loadingRegions$.pipe(takeUntilDestroyed(this)).subscribe(loading => {
      this.loading = loading;
      this.cdRef.detectChanges();
    });

    this.locationSvc.regions$.pipe(takeUntilDestroyed(this)).subscribe(countries => {
      this.regionOptions = countries;
      this.cdRef.detectChanges();
    });
  }

  public get selectPlaceholder(): string | undefined {
    return this.loading ? this.i18n.translate('rti.common.loading') : undefined;
  }
}
